module.exports = __webpack_public_path__ + "img/captains_log.46fbc85b.svg";